// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"540d8bef","227":"67486f6e","641":"2f018a14","719":"67486f6e","744":"4fac5aa6","749":"6c732e42","807":"4fac5aa6"}[chunkId] + ".chunk.css";
};